import {
  HIDE_MESSAGE,
  INIT_URL,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  SHOW_MESSAGE,
  SIGNIN_USER,
  SIGNIN_USER_SUCCESS,
  SIGNOUT_USER,
  SIGNOUT_USER_SUCCESS,
  USER_DATA,
  USER_DATA_SUCCESS,
  USER_TOKEN_SET,
  USER_REFRESH_TOKEN_SET,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAIL,
  CONFIRM_EMAIL,
  CONFIRM_EMAIL_SUCCESS,
  CONFIRM_EMAIL_FAIL,
  CONFIRM_EMAIL_REINIT_STATE,
  REGISTER_USER,
  REGISTER_USER_SUCCESS,
  REGISTER_USER_FAIL,
  MASQUERADE,
  MASQUERADE_SUCCESS,
  MASQUERADE_FAIL,
  MASQUERADE_ADMIN_USER_TOKEN_SET,
  MASQUERADE_ADMIN_USER_REFRESH_TOKEN_SET,
  MASQUERADE_QUIT,
  MASQUERADE_QUIT_RESTORE_TOKENS,
  TOKENOFADMINDURINMASQUERADE_SET,
  REFRESHTOKENOFADMINDURINMASQUERADE_SET,
  MFA_REGISTER,
  MFA_REGISTER_SUCCESS,
  MFA_REGISTER_FAIL,
  MFA_SESSION_TOKEN_SET,
  MFA_VERIFY,
  MFA_VERIFY_SUCCESS,
  MFA_VERIFY_FAIL,
  MFA_LOGIN,
  MFA_LOGIN_SUCCESS,
  MFA_LOGIN_FAIL,
  MFA_REGISTER_DELETE,
  MFA_REGISTER_DELETE_SUCCESS,
  MFA_REGISTER_DELETE_FAIL,
  MFA_RESET_REGISTRATION_FORM,
  MFA_CLOSE_REGISTRATION_FORM,
  MFA_SET_LOGIN_META,
  MFA_SEND_ALT_CODE,
  MFA_SEND_ALT_CODE_SUCCESS,
  MFA_SEND_ALT_CODE_FAIL,
  FETCH_AUTH_USER_DATA,
  FETCH_AUTH_USER_DATA_SUCCESS,
  FETCH_AUTH_USER_DATA_FAIL,
  ADD_NEW_USER_SELF_MANAGED,
  ADD_NEW_USER_SELF_MANAGED_SUCCESS,
  ADD_NEW_USER_SELF_MANAGED_FAIL,
  FETCH_NEW_COMPANY,
  FETCH_NEW_COMPANY_SUCCESS,
  FETCH_NEW_COMPANY_FAIL,
  ADD_NEW_COMPANY,
  ADD_NEW_COMPANY_SUCCESS,
  ADD_NEW_COMPANY_FAIL,
  MANUAL_TOKEN_REFRESH,
  MANUAL_TOKEN_REFRESH_SUCCESS,
  MANUAL_TOKEN_REFRESH_FAIL,
  INITIATE_PRODUCT_TOUR_FOR_PAGE,
  INITIATE_PRODUCT_TOUR_FOR_PAGE_SUCCESS, INITIATE_PRODUCT_TOUR_FOR_PAGE_FAIL,
} from 'constants/ActionTypes';
import {
  RESET_PASSWORD,
  RESET_PASSWORD_FAIL, RESET_PASSWORD_SET_INITIAL_VALUES,
  RESET_PASSWORD_SUCCESS,
  SIGNOUT_USER_BY_TIMEOUT
} from "../constants/ActionTypes";

// export const userSignUp = (user) => {
//   return {
//     type: SIGNUP_USER,
//     payload: user
//   };
// };
export const userSignIn = (user) => {
  return {
    type: SIGNIN_USER,
    payload: user
  };
};

// export const userDataFetch = () => {
//   return {
//     type: FETCH_USER_DATA
//   };
// };

export const userSignOut = () => {
  return {
    type: SIGNOUT_USER,
  };
};
// export const userSignUpSuccess = (authUser) => {
//   return {
//     type: SIGNUP_USER_SUCCESS,
//     payload: authUser
//   };
// };

export const userSignInSuccess = () => {
  return {
    type: SIGNIN_USER_SUCCESS
  }
};


export const setUserToken = (token) => {
  //TODO: jfd for some reason this action appears to fire but not getting picked up by reducer. Investigate. State is not being updated.
  // console.log("setUserToken action is firing with token. This should update the state via the reducer.:", token);

  return {
    type: USER_TOKEN_SET,
    payload: token
  }
};
export const setUserRefreshToken = (token) => {
  // console.log("setUserRefreshToken action is firing with refreshToken. This should update the state via the reducer.:", token);
  return {
    type: USER_REFRESH_TOKEN_SET,
    payload: token
  }
};

export const userDataSuccess = () => {
  return {
    type: USER_DATA_SUCCESS
  }
};

export const setUserData = (data) => {
  console.log("setUserData with ", data);
  return {
    type: USER_DATA,
    payload: data
  }
};

export const fetchAuthUserData = () => {
  console.log("fetchAuthUserData ", );
  return {
    type: FETCH_AUTH_USER_DATA,
  }
};

export const fetchAuthUserDataSuccess = (data) => {
  // console.log("fetchUserDataSuccess ", );
  return {
    type: FETCH_AUTH_USER_DATA_SUCCESS,
    payload: data
  }
};

export const fetchAuthUserDataFail = (data) => {
  // console.log("fetchUserDataSuccess ", );
  return {
    type: FETCH_AUTH_USER_DATA_FAIL,
    payload: data
  }
};

export const userSignOutSuccess = () => {
  return {
    type: SIGNOUT_USER_SUCCESS,
  }
};

export const userSignOutByTimeout = (wasIdle) => {
  if (wasIdle) {
    return {
      type: SIGNOUT_USER_BY_TIMEOUT,
      payload: {wasIdle: true}
    }
  } else {
    return {
      type: SIGNOUT_USER_BY_TIMEOUT,
    }
  }
};

export const showAuthMessage = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message
  };
};


export const setInitUrl = (url) => {
  return {
    type: INIT_URL,
    payload: url
  };
};

export const showAuthLoader = () => {
  return {
    type: ON_SHOW_LOADER,
  };
};

// export const hideMessage = () => {
//   return {
//     type: HIDE_MESSAGE,
//   };
// };
export const hideAuthLoader = () => {
  return {
    type: ON_HIDE_LOADER,
  };
};

export const setNewPasswordAction = (newPw) => {
  return {
    type: CHANGE_PASSWORD,
    payload: newPw
  };
};

export const setNewPasswordSuccess = () => {
  return {
    type: CHANGE_PASSWORD_SUCCESS
  };
};

export const setNewPasswordFail = () => {
  return {
    type: CHANGE_PASSWORD_FAIL
  };
};


/*  jfd*******************************
 *   /reset for password resets
     ********************************** */
export const resetPasswordAction = (usernameAndEmail) => {
  return {
    type: RESET_PASSWORD,
    payload: usernameAndEmail
  };
};

export const resetPasswordSetIntialValues = () => {
  return {
    type: RESET_PASSWORD_SET_INITIAL_VALUES
  };
};

export const resetPasswordSuccess = () => {
  return {
    type: RESET_PASSWORD_SUCCESS
  };
};

export const resetPasswordFail = () => {
  return {
    type: RESET_PASSWORD_FAIL
  };
};

/*  jfd*******************************
 *   /reset for confirmatino of email (is_activated)
     ********************************** */
export const confirmEmailAction = (confirmationCode) => {
  return {
    type: CONFIRM_EMAIL,
    payload: confirmationCode
  };
};

export const confirmEmailSuccess = () => {
  return {
    type: CONFIRM_EMAIL_SUCCESS
  };
};

export const confirmEmailSetInitialValues = () => {
  return {
    type: CONFIRM_EMAIL_REINIT_STATE
  };
};

export const confirmEmailFail = () => {
  return {
    type: CONFIRM_EMAIL_FAIL
  };
};

/*  jfd*******************************
 *   /reset for registering new user
     ********************************** */
export const registerUserAction = (userInfo) => {
  return {
    type: REGISTER_USER,
    payload: userInfo
  };
};

export const registerUserSuccess = () => {
  return {
    type: REGISTER_USER_SUCCESS
  };
};

export const registerUserFail = () => {
  return {
    type: REGISTER_USER_FAIL
  };
};


/* ****************
Masquerade to view app as any user or customer
 *******************/
const masquerade = (userId = null, customerId = null, saveThisToken, saveThisRefreshToken) => {
  const payload = {
    userId,
    customerId,
    saveThisToken,
    saveThisRefreshToken
  }

  console.log("About to masquerade with this payload", payload);

  return {
    type: MASQUERADE,
    payload
  };
};

export const masqueradeSuccess = (data) => {
  return {
    type: MASQUERADE_SUCCESS,
    payload: data
  };
};

export const masqueradeFail = (data) => {
  return {
    type: MASQUERADE_FAIL,
    payload: data
  };
};

/* ****************
Manual token refresh to allow us to refresh the token at any time from the app not just from a 40x call in axios
 *******************/
/**
 * Summary. manualTokenRefresh.
 *
 * Description. Use the refreshToken in localStorage to fetch a new auth token and set the localStorage, State, and API Authorization Bearer. This version can be called elsewhere in the app, as opposed to the other refresh token function that is deeper within Axios that triggers on API response 40x codes.
 * @return
 *
 * @example
 */
export const manualTokenRefresh = () => {
  const payload = {}

  console.log("About to manualTokenRefresh with this payload", payload);

  return {
    type: MANUAL_TOKEN_REFRESH,
    payload
  };
};

export const manualTokenRefreshSuccess = (data) => {
  return {
    type: MANUAL_TOKEN_REFRESH_SUCCESS,
    payload: data
  };
};

export const manualTokenRefreshFail = (data) => {
  return {
    type: MANUAL_TOKEN_REFRESH_FAIL,
    payload: data
  };
};

/* ****************
Masquerade helper: Masquerade as a user
 *******************/

/**
 * Summary. masqueradeAsUser.
 *
 * Description. Send a masquerade request to view app as the specified user.
 *
 *  @param {number}   userId             The Id of the user to masquerade
 *  @param {string}   saveThisToken             The Admin's token to be saved for when quitting masquerade
 *  @param {string}   saveThisRefreshToken             The Admin's refresh token to be saved for when quitting masquerade
 *
 * @return
 *
 * @example
 */
export const masqueradeAsUser = (userId, saveThisToken, saveThisRefreshToken) => {

  if(userId) {
    return masquerade(userId, null, saveThisToken, saveThisRefreshToken);
  } else {
    return masqueradeFail({
      userId,
      customerId: null,
    })
  }

};

/* ****************
Masquerade helper: Masquerade as a user
 *******************/

/**
 * Summary. masqueradeAsUser.
 *
 * Description. Send a masquerade request to view app as the specified customer.
 *
 *  @param {number}   customerId             The Id of the customer (demo account) to masquerade
 *
 *  @param {string}   saveThisToken             The Admin's token to be saved for when quitting masquerade
 *  @param {string}   saveThisRefreshToken             The Admin's refresh token to be saved for when quitting masquerade
 *
 * @return
 *
 * @example
 */
export const masqueradeAsCustomer = (customerId, saveThisToken, saveThisRefreshToken) => {
  if(customerId) {
    return masquerade(null, customerId, saveThisToken, saveThisRefreshToken);
  } else {
    return masqueradeFail({
      userId: null,
      customerId: customerId,
    })
  }
};

export const setAdminUserTokenPriorToMasquerade = () => {
  return {
    type: MASQUERADE_ADMIN_USER_TOKEN_SET,
    // payload: token
  }
};
export const setAdminUserRefreshTokenPriorToMasquerade = () => {
  return {
    type: MASQUERADE_ADMIN_USER_REFRESH_TOKEN_SET,
    // payload: refreshToken
  }
};

/* ****************
quit masquerade and return to original admin token
 *******************/
export const masqueradeQuit = (tokenOfAdminDuringMasquerade, refreshTokenOfAdminDuringMasquerade) => {
  const payload = {
    savedToken: tokenOfAdminDuringMasquerade,
    savedRefreshToken: refreshTokenOfAdminDuringMasquerade,
  }

  console.log("About to quit masquerade ", payload);

  return {
    type: MASQUERADE_QUIT,
    payload
  };
};

export const setAdminUserMasqueradeTokensBackAsLiveTokens = () => {
  return {
    type: MASQUERADE_QUIT_RESTORE_TOKENS,
    // payload: token
  }
};

export const setUserTokenOfAdminDuringMasquerade = (token) => {
  return {
    type: TOKENOFADMINDURINMASQUERADE_SET,
    payload: token
  }
};
export const setUserRefreshTokenOfAdminDuringMasquerade = (token) => {
  return {
    type: REFRESHTOKENOFADMINDURINMASQUERADE_SET,
    payload: token
  }
};


/* ****************
Multi-Factor Authentication (MFA)
 *******************/
const mfaRegister = (userId = null, mfaPreference, mfaPhone = null) => {
  const payload = {
    userId,
    mfaPreference,
    mfaPhone
  }

  console.log("About to mfaRegister with this payload", payload);

  return {
    type: MFA_REGISTER,
    payload
  };
};

/* ****************
MFA Register helper: will check input of phone number if given.
 *******************/

/**
 * Summary. mfaRegisterWithForm.
 *
 * Description. When MFA registration occurs, this checks to see if a phone number is needed (when mfaPreference is 1 (SMS) or 2 (Phone Call)) and sends the correct action. It also appends a + to the start of the phone number if none was supplied.
 *
 *  @param {number}   userId             The Id of the user
 *  @param {number}   mfaPreference             Status code 0 -3 for totp, sms, phone call, or email
 *  @param {string}   mfaPhone             Phone number if using SMS or Phone Call
 *
 * @return
 *
 * @example
 */
export const mfaRegisterWithForm = (userId = null, mfaPreference, mfaPhone = null) => {
    if(!mfaPhone || typeof mfaPhone !== "string") { //if no phone number, there's a problem
      console.warn("While reading mfaPhone got something that was null or was not a string when there was a phone number.", mfaPreference, mfaPhone);
      return mfaRegisterFail({
            userId: null,
            mfaPreference,
            mfaPhone
          })
    } else {
      //check that phone number has a leading +
      if(mfaPhone.charAt(0) === "+") {
        console.log("MFA Phone number has a leading +")
        return mfaRegister(userId, mfaPreference, mfaPhone);
      } else {
        //add a + and send
        console.log("MFA Phone number does not have a leading +, adding one.")
        return mfaRegister(userId, mfaPreference, `+${mfaPhone}`);
      }
    }
};

export const mfaRegisterSuccess = (data) => {
  return {
    type: MFA_REGISTER_SUCCESS,
    payload: data
  };
};

export const mfaRegisterFail = (data) => {
  return {
    type: MFA_REGISTER_FAIL,
    payload: data
  };
};

export const mfaVerify = (userId = null, mfaAuthCode) => {
  const payload = {
    userId,
    mfaAuthCode
  }

  console.log("About to mfaVerify with this payload", payload);

  return {
    type: MFA_VERIFY,
    payload
  };
};

export const mfaVerifySuccess = (data) => {
  return {
    type: MFA_VERIFY_SUCCESS,
    payload: data
  };
};

export const mfaVerifyFail = (data) => {
  return {
    type: MFA_VERIFY_FAIL,
    payload: data
  };
};

export const setMfaSessionToken = (sessionToken) => {

  return {
    type: MFA_SESSION_TOKEN_SET,
    payload: sessionToken
  }
};

export const mfaLogin = (mfaSessionToken, mfaAuthCode, mfaMethodId = null) => {
  const payload = {
    mfaSessionToken,
    mfaAuthCode,
    mfaMethodId
  }

  console.log("About to mfaLogin with this payload", payload);

  return {
    type: MFA_LOGIN,
    payload
  };
};

export const mfaLoginSuccess = (data) => {
  return {
    type: MFA_LOGIN_SUCCESS,
    payload: data
  };
};

export const mfaLoginFail = (data) => {
  return {
    type: MFA_LOGIN_FAIL,
    payload: data
  };
};

export const mfaRegisterDelete = (userId = null,) => {
  const payload = {
    userId
  }

  console.log("About to mfaRegisterDelete with this payload", payload);

  return {
    type: MFA_REGISTER_DELETE,
    payload
  };
};

export const mfaRegisterDeleteSuccess = (data) => {
  return {
    type: MFA_REGISTER_DELETE_SUCCESS,
    payload: data
  };
};

export const mfaRegisterDeleteFail = (data) => {
  return {
    type: MFA_REGISTER_DELETE_FAIL,
    payload: data
  };
};

export const mfaResetRegistrationForm = () => {
  return {
    type: MFA_RESET_REGISTRATION_FORM
  };
};

export const mfaCloseRegistrationForm = () => {
  return {
    type: MFA_CLOSE_REGISTRATION_FORM
  };
};

export const mfaSetLoginMeta = (data) => {
  return {
    type: MFA_SET_LOGIN_META,
    payload: data
  };
};

export const mfaSendAltCode = (mfaSessionToken, mfaAltMethodId) => {
  const payload = {
    mfaSessionToken,
    mfaAltMethodId
  }

  console.log("About to send an alternative code with this payload", payload);

  return {
    type: MFA_SEND_ALT_CODE,
    payload
  };
};

export const mfaSendAltCodeSuccess = (data) => {
  return {
    type: MFA_SEND_ALT_CODE_SUCCESS,
    payload: data
  };
};

export const mfaSendAltCodeFail = (data) => {
  return {
    type: MFA_SEND_ALT_CODE_FAIL,
    payload: data
  };
};


/*  sarahp*******************************
 *   new user signup, self subscription
     ********************************** */
export const addNewUserSelfManaged = (firstName, lastName, email, password, username, signSLA, ref, promo, homepage) => {
  return {
    type: ADD_NEW_USER_SELF_MANAGED,
    payload: {
      firstName,
      lastName,
      email,
      password,
      username,
      signSLA,
      ref,
      promo,
      homepage
    }
  };
};

export const addNewUserSelfManagedSuccess = (data) => {
  return {
    type: ADD_NEW_USER_SELF_MANAGED_SUCCESS,
    payload: data
  };
};

export const addNewUserSelfManagedFail = (data) => {
  return {
    type: ADD_NEW_USER_SELF_MANAGED_FAIL,
    payload: data
  };
};

/*  sarahp*******************************
 *   self subscription, get new company information for confirmation
     ********************************** */

export const fetchNewCompany = (data)=>{
  return{
    type: FETCH_NEW_COMPANY,
    payload: data
  }
}

export const fetchNewCompanySuccess = (data)=>{
  return{
    type: FETCH_NEW_COMPANY_SUCCESS,
    payload: data
  }
}

export const fetchNewCompanyFail = (data)=>{
  return{
    type: FETCH_NEW_COMPANY_FAIL,
    payload: data
  }
}

/*  sarahp*******************************
 *   self subscription, add new company information
     ********************************** */

export const addNewCompany = (entityId)=>{
  return{
    type: ADD_NEW_COMPANY,
    payload: {
      entityId,
    }
  }
}

export const addNewCompanySuccess = (data)=>{
  return{
    type: ADD_NEW_COMPANY_SUCCESS,
    payload: data
  }
}

export const addNewCompanyFail = (data)=>{
  return{
    type: ADD_NEW_COMPANY_FAIL,
    payload: data
  }
}

/*  sarahp**********11.08.22*****
 *  Start A product walk through independent of user tags
     **********************  */

export const startProductTour = (data)=>{
  return{
    type: INITIATE_PRODUCT_TOUR_FOR_PAGE,
    payload: data
  }
}

export const startProductTourSuccess = (data)=>{
  return{
    type: INITIATE_PRODUCT_TOUR_FOR_PAGE_SUCCESS,
    payload: data
  }
}

export const startProductTourFail = (data)=>{
  return{
    type: INITIATE_PRODUCT_TOUR_FOR_PAGE_FAIL,
    payload: data
  }
}
